import './brokerCryptoTestSignDocumentation.scss';

// @vendors
import React, { useEffect } from 'react'
const { FormattedText, formatText } = require('core/i18n').i18n;
import PropTypes from 'prop-types';

// @components
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import { OKCover } from 'commonsComponents/OKCover';
import { SignaturePattern } from 'components/signaturePattern/signaturePattern';
import { OKLink } from "commonsComponents/OKLink";
import SignaturePatternButton from  'components/signaturePattern/signaturePatternButton/signaturePatternButton';

// @constants
import { SIGN_CRYPTO_DOCUMENTATION } from 'constants/operationTypes';

export default function BrokerCryptoTestSignDocumentation ({ history, signDocument, immBrokerConvenienceMiFIDTest, goToPurchaseFlow }) {

    useEffect(() => {
        const cryptoDocumentationSignLoading = immBrokerConvenienceMiFIDTest.getIn(['test', "cryptoDocumentation", 'cryptoDocumentationSignLoading']);
        const documentationHasSigned = immBrokerConvenienceMiFIDTest.getIn(['test', "cryptoDocumentation", 'documentationHasSigned']);
        if (documentationHasSigned && !cryptoDocumentationSignLoading) {
            goToPurchaseFlow();
        }
    }, [immBrokerConvenienceMiFIDTest]);

    const mappingBreadcrumb = [
        {
            text: formatText('brokerCryptoTest-documentationSignBreadcrumb1'),
        },
        {
            text: formatText('brokerCryptoTest-documentationSignBreadcrumb2'),
        },
        {
            text: formatText('brokerCryptoTest-documentationSignBreadcrumb3'),
        }
    ];

    const boxHeader = (
        <div className="broker-crypto-test-sign-documentation__box-header">
            <h2 className="broker-crypto-test-sign-documentation__box-title">
                {formatText('brokerCryptoTest-documentationSignTitle')}
            </h2>
            <div className="broker-crypto-test-sign-documentation__box-subtitle">
                {formatText('brokerCryptoTest-documentationSignSubtitle')}
            </div>
        </div>
    );

    const boxContent = (
        <div className="broker-crypto-test-sign-documentation__box-content">
            <SignaturePattern
                operationType={SIGN_CRYPTO_DOCUMENTATION}
            />
        </div>
    );

    const boxFooter = (
        <div className="broker-crypto-test-sign-documentation__box-footer">
            <OKLink>
                {formatText('brokerCryptoTest-documentationSignCancel')}
            </OKLink>
            <SignaturePatternButton
                onClick={() => {
                    signDocument(history);
                }}
                loading={immBrokerConvenienceMiFIDTest.getIn(
                    ['test', "cryptoDocumentation", 'cryptoDocumentationSignLoading'])
                }
            >
                {formatText('brokerCryptoTest-documentationSignConfirm')}
            </SignaturePatternButton>
        </div>
    );

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" customClass="col-xs-12 broker-crypto-test-sign-documentation__cover">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            isSubtitleLeftCapital={false}
                            finalTitle={formatText('brokerCryptoTest-documentationSignHeaderSubPageTitle')}
                        />
                    </OKCover>
                </div>
            </div>

            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <OKSectionBox className="broker-crypto-test-sign-documentation">
                            {boxHeader}
                            {boxContent}
                            {boxFooter}
                        </OKSectionBox>
                    </div>
                </div>
            </div>
        </>
    )
}

BrokerCryptoTestSignDocumentation.propTypes = {
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    goToPurchaseFlow: PropTypes.func.isRequired,
    signDocument: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
};
